export default __webpack_public_path__ + "static/media/img-1.c207c737.jpg";